module.exports = __webpack_public_path__ + "static/img/EG.9085722e.svg";